import cookie from 'react-cookies'
const ACCESS_TOKEN = 'accessToken'
const REFRESH_TOKEN = 'refreshToken'

export const createAccess = (value) => {
  let expDate = new Date()
  expDate.setTime(expDate.getTime() + 10 * 3600 * 1000)

  cookie.save(ACCESS_TOKEN, value, {path: '/', expires: expDate})
  sessionStorage.setItem(ACCESS_TOKEN, value)
}

export const createRefresh = (value) => {
  let expDate = new Date()
  expDate.setTime(expDate.getTime() + 10 * 3600 * 1000)

  cookie.save(REFRESH_TOKEN, value, {path: '/', expires: expDate})
  sessionStorage.setItem(REFRESH_TOKEN, value)
}

export const removeCookie = () => {
  cookie.remove(ACCESS_TOKEN)
  cookie.remove(REFRESH_TOKEN)
  sessionStorage.clear()
}

export const loadAccessToken = () => {
  return cookie.load(ACCESS_TOKEN)
}

export const loadRefreshToken = () => {
  return cookie.load(REFRESH_TOKEN)
}
